import { clsx } from 'clsx';

export interface SectionHeaderProps {
  /** Section title text */
  title: string;
  /** Optional action link text (e.g., "EDIT", "REMOVE") */
  action?: string;
  /** Called when the action link is clicked */
  onAction?: () => void;
  /** Additional className for the container */
  className?: string;
}

/**
 * SectionHeader - Atom component for section titles with optional action links
 *
 * Renders a section heading with an optional right-aligned action link.
 * Used for collapsible sections like Details, Payment in the booking flow.
 */
export function SectionHeader({ title, action, onAction, className }: SectionHeaderProps) {
  return (
    <div className={clsx('flex items-center justify-between', className)}>
      <h3 className="font-sailec text-dorsia-black text-lg font-medium">{title}</h3>
      {action && (
        <button
          type="button"
          onClick={onAction}
          className="font-sailec text-dorsia-black cursor-pointer text-xs font-medium uppercase tracking-wider underline"
        >
          {action}
        </button>
      )}
    </div>
  );
}
